import React, { useEffect, useState } from 'react';
import AssemblyForm from './AssemblyForm';
import ModalContext from '../../components/Context/ModalContext';
import { IAssembly } from '../../graphql/schema/p4types';
import { alternateFullScreenModalStyle } from '../../components/modals/Styles';
import FluentModal from '../../components/modals/FluentModal';

const AssemblyModal = ({
  modalOpen,
  tempAssembly,
  onClose,
  onSubmitSuccess,
}: {
  modalOpen: boolean;
  tempAssembly: IAssembly | null;
  onClose: () => void;
  onSubmitSuccess: (result?: IAssembly) => void;
}) => {
  const [isOpen, setIsOpen] = useState(modalOpen);
  useEffect(() => {
    //'modalOpen' prop is source-of-truth, however we want to "minimize" the modal while the background job runs before we call props.close, to ensure data is all in-sync as expected.
    setIsOpen(modalOpen);
  }, [modalOpen]);

  return (
    <FluentModal isOpen={isOpen}>
      <div style={{ height: window.innerHeight, position: 'relative', width: '80vw' }}>
        <ModalContext.Provider value={{ onClose, style: alternateFullScreenModalStyle }}>
          <AssemblyForm
            modalClose={true}
            saveViaWrappingComponent={true}
            formData={{ defaultRecord: tempAssembly }}
            onSubmitSuccess={onSubmitSuccess}
            noDeleteOption={true}
            saveOptions={[
              {
                value: 'EXIT',
                label: 'Save Draft & Exit',
              },
            ]}
          />
        </ModalContext.Provider>
      </div>
    </FluentModal>
  );
};

export default AssemblyModal;
